module.exports = __webpack_public_path__ + "static/media/search.d7bfcf36.svg";